package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object TurkishStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "İptal edildi, ${p0} tarihinde süresi doluyor "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "Hesap"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "Zaten bir hesabınız var gibi görünüyor! Yalnızca yeni hesaplar, tavsiye yoluyla ücretsiz üyelik için uygundur. Afedersiniz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "İlginiz için teşekkür ederiz! Ortaklık programımızı sonlandırdık, bu yüzden maalesef yok. Üzgünüz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "Tavsiye veya ortaklık programınız var mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "Satın alınabilirlik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "Bize durumunuzu anlatın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "Misyonumuz, dünyaya büyük ölçüde uygun fiyatlı fitness sağlamaktır. Down Dog şu anda bütçenize uygun değilse, bize durumunuzu açıklayan bir mesaj gönderin, ne yapabileceğimizi görelim!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "Airplay"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "Ekran yansıtma kullanarak Down Dog pratiğinizi AirPlay yapabilirsiniz! Daha fazla bilgi için <a href=\"https://support.apple.com/en-us/HT204289\"> Apple'ın destek sayfasına </a> gidin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "AirPlay'i destekliyor musunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "Hepsi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "Tüm Uygulamalar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "Şu anda, abonelik satın alımları, Down Dog Yoga, HIIT, Bar ve Hamile Yogası dahil tüm uygulamalarımıza erişmenizi sağlar!\n\nŞu anda tek bir uygulama satın alma seçeneği sunmuyoruz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "Aboneliğim bir uygulama için mi yoksa tüm uygulamalar için mi?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "Tüm Pozlar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "${p0} olarak gösterilen tüm tutarlar. Ödeme verileriniz şifrelenir ve güvendedir.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "ve"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "Evet! Bağlantı konusunda sorun yaşıyorsanız, işte bazı ipuçları:\n1. Uygulamanızın Health'e bağlı olup olmadığını kontrol edin. Uygulamayı açın ve menüye gidin (sağ alttaki üç yatay çizgi düğmesine basın), Apple Health'e Bağlanma seçeneği var mı? Öyleyse, o seçeneği tıklayın.\n2. Telefonunuzdaki Sağlık Uygulamasını açın ve veri kaynakları sekmesine tıklayın. Down Dog bir veri kaynağı olarak listeleniyor mu? Bu, Down Dog'un bağlı olduğunu iki kez kontrol etmek içindir. Değilse (ancak Down Dog içinde bağlantı kurma seçeneği yoksa), bize bildirin!\n3. Uygulamayı kaldırıp yeniden yüklemeyi ve ardından oturum açıp Apple Health'e yeniden bağlanmayı deneyin.\n\nMaalesef, Apple Health iPad'de desteklenmiyor ve uygulamalarınızı cihazlar arasında takip etmeyi desteklemiyoruz (ancak bir gün olabilir)."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "Uygulamalar Apple Health'e bağlanıyor mu?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "Maalesef Apple, App Store'dan satın alınan abonelikleri iptal etmemize veya iade etmemize izin vermiyor. Aboneliğinizi nasıl iptal edeceğinizle ilgili olarak Apple'dan bazı talimatlar şöyle: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "Facebook grubuna sor"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "Otomatik Yenileme Kapalı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "Otomatik Yenileme Açık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b> Aboneliğinizi Nasıl Yönetir veya İptal Edersiniz? </b>\n\nAboneliğinizi <em> web'den </em> satın aldıysanız:\n1. <b> Ayarlar </b> 'a gidin. Mobilde, ekranın sağ alt tarafındaki üç yatay çizgiye dokunarak oraya gidebilirsiniz. Web'de Ayarlar sol kenar çubuğundadır.\n2. <b> Ayarlar </b> altında, <b> Abonelik </b> 'e dokunun.\n3. Ardından, otomatik yenilemeyi kapatma dahil olmak üzere aboneliğinizi nasıl iptal edeceğiniz veya değiştireceğiniz dahil daha fazla bilgi görmelisiniz.\n\nAboneliğinizi <em> mobil uygulama </em> üzerinden satın aldıysanız, aboneliğinizi <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> adresinden yönetebilirsiniz. Apple App Store </a> veya <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=tr\" target=\"_blank\"> Google Play Store üzerinden </a>.\n\n<b> Aboneliğiniz Hakkında </b>\n\nWeb sitemiz, Apple veya Google üzerinden açıkça bir üyelik satın almadığınız sürece hiçbir abonelik için ücret alınmayacaktır. Abonelikler, aboneliği satın alırken kullandığınız e-posta adresinin altında bulunur. Hesabınızda listelenen bir abonelik görmüyorsanız, şu anda oturum açmış olduğunuz e-posta adresiyle ilişkili bir aboneliğiniz olmadığı anlamına gelir. Aboneliğinizin başka bir e-posta adresiyle ilişkilendirilmiş olması mümkündür ve bu durumda, aboneliğinizi görmek için oturumu kapatıp o e-posta adresi altında tekrar oturum açmanız gerekecektir.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "Otomatik yenilemeyi devre dışı bırakmak istiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "Geri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "Bar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "Barre Egzersizi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "Faturalandırma"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "Faturalandırma - geri ödeme"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "Nefes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "Nefes Çalışması Uygulaması"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "İptal et"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "İndirmeyi İptal Et"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "Maalesef hesaplarınızı birleştiremiyoruz.\n\nErişim elde etmek için lütfen aboneliğinizi satın alırken kullandığınız e-posta ile oturum açtığınızdan emin olun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "Birden fazla hesabım var. Onları birleştirebilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "Yanlışlıkla birden fazla Down Dog hesabı oluşturmuş gibisiniz. Uygulamadan çıkış yapmayı ve kullanmış olabileceğiniz diğer e-posta adresleriyle tekrar giriş yapmayı denemelisiniz. Aboneliğinizin tüm uygulamalarımızda ve tüm cihazlarınızda (web sürümü dahil) çalıştığını, ancak satın alma işlemi için kullandığınız e-posta ile oturum açmanız gerektiğini unutmayın. <em> Apple, Google ve PayPal'ın Down Dog</em>'da oturum açmak için kullandığınız e-posta adresine değil, bu hizmetlerle ilişkilendirdiğiniz e-posta adresine makbuz göndermiş olabileceğini unutmayın.\n\nApple iTunes veya Google Play'i kullanarak mobil uygulama içinden abone olduysanız, uygulama menüsünden <b> Uygulama İçi Satın Almayı Geri Yükle </b> 'yi tıklamayı denemelisiniz. Bunu, orijinal satın alma işlemini yaptığınız uygulamanın içinden yaptığınızdan emin olun.\n\nPayPal ile abone olduysanız ve aboneliğinize erişiminiz yoksa, ödemeniz büyük olasılıkla başarılı olmamıştır. Bunu PayPal hesabınızdan veya yalnızca birkaç gün süren bir abonelik göreceğiniz uygulamanın menüsünü ziyaret ederek kontrol edebilirsiniz. Bu durumda, gerçekte sizden ücret alınmaz ve <a href=\"/purchase\"> downdogapp.com/purchase </a> adresini ziyaret ederek satın alma işlemini yeniden yapmayı deneyebilirsiniz. PayPal kullanmak yerine doğrudan kredi kartıyla ödeme yapmakta daha başarılı olabilirsiniz.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "Aboneliğime erişemiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "Yayınla"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "Evet, yakın zamanda mobil ve web uygulamalarına Chromecast desteği ekledik!\n\nChromecast'in mobil uygulamada nasıl kullanılacağı aşağıda açıklanmıştır:\n1. Chromecast özellikli cihazınızın (TV gibi) açık olduğundan ve Android / iOS cihazınızla aynı WiFi ağında bulunduğundan ve ayrıca uygulamanın en son sürümüne sahip olduğunuzdan emin olun.\n2. Bir uygulama başlatın.\n3. Kontrolleri görüntülemek için ekrana dokunun, ardından sağ üstteki <b> Chromecast düğmesine </b> dokunun (alt köşesinde üç çeyrek daire bulunan bir dikdörtgene benzer).\n4. Uygulamanın TV'nize yüklenmesi için bir dakika kadar bekleyin, ardından Android / iOS cihazınızda oynat'ı tıklayın.\n\nVe Chromecast'i web uygulamasında şu şekilde kullanabilirsiniz:\n1. Chromecast özellikli cihazınızın (TV gibi) açık olduğundan ve bilgisayarınızla aynı WiFi ağında olduğundan emin olun.\n2. <b> Chrome </b> 'u kullanarak web uygulamasında bir alıştırma başlatın.\n3. Sağ alttaki <b> Chromecast düğmesini </b> tıklayın (alt köşede üç çeyrek daire bulunan bir dikdörtgene benzer).\n4. Uygulamanın TV'nize yüklenmesi için bir dakika kadar bekleyin ve ardından bilgisayarınızda oynat'ı tıklayın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "Chromecast'i destekliyor musunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b> CAST DÜĞMENİZ görünmüyorsa: </b>\n\n1. Bir uygulama başlatın, ardından durun. Yayın düğmesini görüyor musunuz (Android / iOS için sağ üst köşe; web uygulaması için sağ alt köşe)? Uygulama sırasında yalnızca cast düğmesini gösteririz.\n\n2. Aynı cihazdan başka bir şey (ör. YouTube) yayınlamayı deneyin. O halde bir yayın düğmesi görüyor musunuz? Değilse, Chromecast özellikli cihazınızın (TV gibi) açık olduğundan ve bilgisayarınız veya Android / iOS cihazınız ile aynı WiFi ağında olduğundan emin olun. Bilgisayar kullanıyorsanız, Chrome kullandığınızdan emin olun.\n\n3. Farklı bir cihazdan yayın yapmayı deneyin. Android / iOS kullanıyorsanız bilgisayarınızdaki web uygulamasından yayınlamayı deneyin veya tersini yapın.\n\n4. Telefonunuzdaki Down Dog uygulamaları için pil optimizasyonunu kapatmayı deneyin. Bu, uygulamanın birkaç dakika işlem yapılmadığında güç tasarrufu moduna geçmek yerine Chromecast cihazınızla iletişim kurmaya devam etmesini sağlar.\n\n\n<b> \"BAĞLISINIZ\" ancak video oynatılmıyorsa: </b>\n\nÖncelikle, Down Dog'un TV'nize yüklenmesi için yeterince beklediğinizden emin olun. Yükleme 60 saniyeye kadar sürebilir. Bu süre boyunca, TV'niz başlangıçta alt kısımda sarı bir \"yükleme\" çubuğu gösterecek, ardından karararak siyaha dönecektir. Yükleme tamamlandıktan sonra TV'niz videoyu gösterecektir.\n\n60 saniye sonra TV ekranınız hala siyahsa veya siyah ekranın ortasında \"Aşağı Köpek\" kelimeleri görünüyorsa, pratiğinizden çıkın ve tekrar deneyin. Aynı uygulamayı Geçmiş sekmesinden (Android / iOS için ekranınızın altındaki saat simgesi; web için sol kenar çubuğunda) yeniden başlatabilirsiniz.\n\n\n<b> Yayınınız birkaç dakikalık oynatmadan sonra KOPUYORSA: </b>\n\n1. WiFi sinyal gücünüzü kontrol edin. Chromecast'inizin veya telefonunuzun / bilgisayarınızın sinyali zayıfsa, sinyal gücünü bir WiFi genişletici kullanarak veya yönlendiricinize yaklaştırarak artırabilirsiniz.\n\n2. Telefonunuzdaki Down Dog uygulamaları için pil optimizasyonunu kapatın. Bu, uygulamanın birkaç dakika işlem yapılmadığında güç tasarrufu moduna geçmek yerine Chromecast cihazınızla iletişim kurmaya devam etmesini sağlar.\n\n3. Bu sorunu çözmezse, yönlendiricinizi yeniden başlatmayı da deneyebilirsiniz.\n\n4. Son olarak, statik bir IP adresi kullanmak için telefonunuzun kayıtlı wifi bağlantı ayarlarını düzenlemeyi deneyin.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "Chromecast ile sorun yaşıyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "${p0} cihazına yayınlanıyor"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "E-posta"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "E-posta"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "Meydan Okuma Güncellemeleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "Topluluk ve meydan okuma ilerlemeniz hakkında güncellemeler alın!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "Günlük Hatırlatıcılar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "Ocak ayında her gün pratik yapmanız için hatırlatıcılar alın!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "A: Meydan okumayı tamamlamak için ayın her günü bir uygulama tamamlamalısınız. Herhangi bir Down Dog uygulamasını kullanabilirsiniz. Uygulamalar tam olarak tamamlanmalıdır."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "C: Down Dog, uygulamanızın Yolculuk sayfasındaki takvimi kullanarak ilerlemenizi takip edecek! Her gün pratik yaptığınızda ve takvim tarihini mavi olarak gördüğünüzde, bu tarih meydan okuma ilerlemenize doğru takip edilir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "C: Günlük hatırlatıcılarımızı, bir önceki gün yaptığınız pratiğe göre gönderiyoruz. Bu yüzden, normalde yapacağınızdan daha erken bir saatte pratik yaptıysanız, bizden önce davranmış olabilirsiniz! Yolculuğunuz sayfasındaki takvimde pratiklerinizin izlendiğini gördüğünüz sürece, bunlar meydan okuma ilerlemenize dahil edilir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "C: Hayır. Çok üzgünüz, ancak Down Dog uygulamasında tamamlanmamış uygulamaları geçmişinize ekleyemiyoruz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "C: Seyahat ediyorsanız ve saat dilimlerini değiştiriyorsanız, bu durum meydan okuma serinizi etkileyebilir. Şu anda, sistemimiz uygulama geçmişinizi uygulama yaptığınız zamandaki saat dilimine göre kaydediyor. Bu, uygulama tarihlerinizin orijinal saat diliminizle değil, mevcut saat diliminizle uyumlu olacağı anlamına gelir. Serinizi korumak için, mümkün olduğunca orijinal saat diliminizle uyumlu bir zamanda uygulama yapmanızı öneririz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "C: Kazananlar, meydan okumayı tamamlayan kullanıcılar grubundan rastgele seçilir. Kazananlarla meydan okuma sonunda bireysel olarak iletişime geçilir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "S: Gereksinimler nelerdir?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "S: İlerlemem nasıl takip ediliyor?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "S: Günlük bildirimler için kaydoldum ama bugün bir bildirim almadım, bir sorun mu var?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "S: Başka bir yerde bir uygulama tamamladım - uygulama geçmişime eklenebilir mi?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "S: Meydan okuma sırasında seyahat ediyorum. Bu bir şeyi etkiler mi?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "S: Ürün kazananları nasıl seçilir ve iletişime geçilir?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "Down Dog Meydan Okuma SSS"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "Herhangi bir iletişim almayı tercih ettiğiniz için, Down Dog'dan meydan okuma ile ilgili herhangi bir ilerleme güncellemesi veya hatırlatıcı almayacaksınız."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "Emin misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "Bildirimler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "Dikkat! Daha önce Down Dog'dan e-posta iletişimini almaktan çıkmıştınız. Meydan okuma içinde e-posta iletişimini etkinleştirerek, hesabınızın otomatik olarak bizden e-posta iletişimleri almaya yeniden başlamasını sağlayacağız."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. <b> Ayarlar </b> 'a gidin. Mobilde, ekranın sağ alt tarafındaki üç yatay çizgiye dokunarak oraya gidebilirsiniz. Web'de Ayarlar sol kenar çubuğundadır.\n2. <b> Hesap </b> altında, <b> E-posta </b> 'ya dokunun ve kullanmak istediğiniz e-postayı girin\n3. <b> Kaydet </b> 'e dokunun"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "Hesabımla ilişkili e-postayı nasıl değiştiririm?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "Dili Değiştir"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "Dili, <b> Ayarlar </b> 'a giderek (mobil uygulamada, sağ alttaki 3 yatay çizgiye dokunun ve web uygulamasında Ayarlar sol kenar çubuğunda olacaktır) ve ardından <b öğesine dokunarak değiştirebilirsiniz. > Dil </b>!\n\nBar, HIIT ve 7-Dakika uygulamalarımız için, dili değiştirdikten sonra bile talimatları İngilizce olarak duymaya devam edeceksiniz. Bu uygulamalar için çevrilmiş sesli talimatlar yakında geliyor!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "Aaa! Dilinizi değiştirmek için internete bağlı olmanız gerekir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "Duyduğum dili nasıl değiştiririm?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "1. <b> Ayarlar </b> 'a gidin. Mobilde, ekranın sağ alt tarafındaki üç yatay çizgiye dokunarak oraya gidebilirsiniz. Web'de Ayarlar sol kenar çubuğundadır.\n2. <b> Hesap </b> altında, <b> Şifre </b> 'ye dokunun ve Şifre ve Şifreyi Onayla alanlarına kullanmak istediğiniz yeni şifreyi girin\n3. <b> Kaydet </b> 'e dokunun\n\nŞifrenizi unuttuysanız, giriş ekranına e-postanızı ve yanlış bir şifre girmeniz yeterlidir. Ardından, <b> Şifrenizi mi unuttunuz? </b> seçeneğini tıklayın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "Şifremi nasıl değiştirebilirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "Birçok müzik kategorisi sunuyoruz ve sürekli olarak yeni seçenekler ekliyoruz! Uygulamada, ayarlar görünümünü yukarı kaydırıp <b> Müzik </b> 'e dokunarak müzik stilini değiştirebilirsiniz! Web sürümünde, ayarlar arasında gezinebilir ve <b> Müzik </b> seçeneğini tıklayabilirsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "Müziği nasıl değiştiririm?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "Aaa! Bu pratik için görselleri değiştirmek için internet bağlantısına ihtiyacınız olacak."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "Şu anda yoga uygulamalarımızda birden fazla İngilizce konuşan ses sunuyoruz. Mobil cihazda, ana ayarlar sayfasını yukarı kaydırıp ardından <b> Ses </b> 'e dokunarak duyduğunuz sesi değiştirebilirsiniz. Web'de, <b> Ses </b> seçeneğini tıklayabilirsiniz.\n\nAyrıca yoga uygulamalarımızda İngilizce olmayan birkaç ses de sunuyoruz. Dili, <b> Ayarlar </b> 'a giderek (mobil uygulamada, sağ alttaki 3 yatay çizgiye dokunun ve web uygulamasında Ayarlar sol kenar çubuğunda olacaktır) ve ardından <b öğesine dokunarak değiştirebilirsiniz. > Dil </b>!\n\nBar uygulamamızda şimdilik sadece bir ses var, ancak gelecekte ek diller ve sesler eklemeyi planlıyoruz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "Duyduğum sesi nasıl değiştiririm?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "İki kez ödedim."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "Sorunuzun orada yanıtlanıp yanıtlanmadığını görmek için ${p0} sayfamıza bakın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "Uygulama geçmişinizden tüm uygulamaları silmek istediğinizden emin misiniz? Bu eylem geri alınamaz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "Kapat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "Facebook'ta tavsiye istemek için katılabileceğiniz canlı ve destekleyici bir <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\"> Down Dog Topluluğu </a> var. ilerlemenizi paylaşın!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "Yolculuğum sırasında topluluk için can atıyorum! Sorularım olduğunda beni desteklemek için katılabileceğim bir grup var mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "Evden çalışan personel 1 Haziran'a kadar ücretsiz üyelik için uygundur!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "Bu indirmeyi iptal etmek istediğinizden emin misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "Bu çevrimdışı uygulamayı silmek istediğinizden emin misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "Şifreyi Onayla"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "Apple Health'e bağlanın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "Google Fit'e bağlanın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "Uygulamalarınız artık otomatik olarak Apple Health'e kaydedilecek!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "Uygulamalarınız artık otomatik olarak Google Fit'e kaydedilecek!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "Bağlanıyor..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "Bağlantı sorunu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "İletişim"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "Para iadesi istiyorsanız, Apple destek ile iletişime geçmeli ve geri ödeme alabileceğimizi onlara bildirmelisiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "Devam et"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "Kurumsal Üyelik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "Geri Sayım Saati"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "Çevrimdışı Uygulama Oluştur"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "Mevcut ayarlarınızla bir uygulama oluşturup indirmek mi istiyorsunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "Özel"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "Sil"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "Hesabı Sil"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "Hesabınız TÜM Down Dog uygulamaları için KALICI OLARAK silinecek ve aboneliğinizi otomatik olarak iptal edeceğiz. Devam et?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "Bizden ayrılmaya karar verirseniz, hesabınızı mobil uygulamadan veya web uygulamasından silebilirsiniz. Lütfen hesabınız silindikten sonra geri yüklenemeyeceğini ve geçmişinizi ve kayıtlı uygulamalarınızı kaybedeceğinizi unutmayın!\n\n1. <b> Ayarlar </b> 'a gidin. Mobilde, ekranın sağ alt tarafındaki üç yatay çizgiye dokunarak oraya gidebilirsiniz. Web'de Ayarlar sol kenar çubuğundadır.\n2. <b> Ayarlar </b> altında, <b> Verilerim </b> 'e gidin ve <b> Hesabı Sil </b>' e dokunun\n3. Açılır kutu istendiğinde, <b> Tamam </b> 'a dokunun"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "Hesabınızı silmek istediğinizden emin misiniz? Bu eylem geri alınamaz. Tüm Down Dog uygulamaları için hesabınız kalıcı olarak silinecek."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "Hesabımı nasıl silerim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "TÜM Down Dog uygulamaları için hesabınızı kalıcı olarak silmek üzeresiniz. BU EYLEM GERİ ALINAMAZ. Devam etmek istiyor musun?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "TÜM Down Dog uygulamaları için hesabınız kalıcı olarak silinecek. İptal edene kadar aboneliğiniz HALA ÜCRETLİ OLACAKTIR. Devam et?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "Uygulama Geçmişini Temizle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "Çevrimdışı Uygulamayı Sil"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "Evet! Abone olduğunuzda kullandığınız e-postayı oturum açmak için kullandığınızdan emin olun."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "Aboneliğim tüm cihazlarımdaki (dizüstü bilgisayar, telefon, tablet vb.) Antrenmanlara erişmeme izin veriyor mu?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "Bir abonelik satın almadınız."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "Beğenme"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "Aboneliğimi görmüyorum"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "İndir"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "İndirme işlemi tamamlandıktan sonra bu uygulamayı Çevrimdışı Uygulamalar sayfasında bulabilirsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "Uygulama İndir"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "İndirme Başladı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "İndiriliyor... %${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "Düzenle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "E-postayı Düzenle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "Adı Düzenle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "Şifreyi Düzenle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "Eposta"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "E-posta ve Şifre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "İngilizce poz isimleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1. Ayarlar uygulamanızı açın.\n\n2. Bildirimler'e gidin.\n\n3. ${p0} uygulamasını bulun ve <b>bildirimlerin etkin olduğundan</b> emin olun."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "Mobil cihazlarınızda Down Dog için push bildirimlerinin etkinleştirildiğinden emin olun."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "Kodu Girin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "Email adresini gir"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "Şifre girin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "Ekipman"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "Aaa! Sağlık uygulamasına bağlanırken bir hata oluştu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "Aaa! Google Fit'e bağlanırken bir hata oluştu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "Bir hata oluştu. Destek için lütfen bizimle iletişime geçin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b> HIIT </b> \n\nEvet! Uygulama altında, <b> Karıştır </b> 'a dokunun. Oradan, her vücut bölümünün solundaki + işaretine dokunun ve bir egzersiz listesi göreceksiniz. Uygulamanızın dışında bırakmak istediğiniz belirli alıştırmalara dokunun. \n\n<b> Yoga, Doğum Öncesi, Bar </b> \n\nŞu anda bu özelliğe sahip değiliz, ancak kesinlikle listemizde var! Şimdilik, mobil uygulamada, yukarı geldiğinde <b> sola kaydırarak </b> sevmediğiniz pozları atlayabilirsiniz. Web uygulamasında, ekranın sol alt kısmındaki <b> ileri ok </b> 'u tıklayın.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "Belirli pozları pratiğimden çıkarabilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "Egzersiz tavsiyesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "Egzersiz Listesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "Egzersiz İsimleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "Çıkış"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "Pratikten Çık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "Mevcut pratiğinizi bırakmak istediğinizden emin misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "Müstehcen Şarkı Sözleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "Facebook Kimlik Doğrulama Hatası. Lütfen daha sonra tekrar deneyiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "Facebook Topluluğu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "Alıştırma indirilemedi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "Bu uygulama indirilirken bir şeyler ters gitti. Lütfen tekrar deneyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "Maalesef, Apple Aile Paylaşımı'nı desteklemiyoruz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "Aboneliğimi aile üyelerimle paylaşabilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "SSS Sayfası"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "Favorilere Ekle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "Favoriler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "Özellik isteği"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "Geri bildirim (isteğe bağlı)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "Yazdığınız için teşekkürler!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "Alıştırma Oluşturma..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "Hayır."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "Uygulamalar FitBit'e bağlanıyor mu?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "Parolanızı mı unuttunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "Şifrenizi sıfırlamak için önce e-postanızı girin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "Sağlık Çalışanları için Ücretsiz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "Okullar için Ücretsiz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "Ücretsiz Kurumsal Üyelik Alın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "Sağlık Hizmeti Üyeliği Alın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "Öğrenci Üyeliği Alın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "Hayır. Şu anda böyle bir hizmetimiz yok."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "Down Dog hediyenizi (veya hediyelerinizi!) satın alın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "Arkadaşlarınıza ve ailenize yazdırabileceğiniz veya gönderebileceğiniz bir Hediye Sertifikası alın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "Alıcılar, hazır olduklarında erişim yıllarını başlatmak için Sertifikalarındaki QR kodunu kullanabilirler!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "Nasıl çalışır:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "Abonelik hediye edebilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "Apple Destek'e gidin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "Hedef Serisi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "Hedef serisi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "Google Kimlik Doğrulaması Hatası. Lütfen daha sonra tekrar deneyiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "Evet! Bağlanma konusunda sorun yaşıyorsanız, işte bazı ipuçları:\n\nUygulamayı açın ve menüye gidin (sağ alttaki 3 dikey çizgiyi tıklayın). Google Fit'e Bağlan seçeneği varsa bu, Down Dog'un şu anda Google Fit'e bağlı olmadığı anlamına gelir. Öyleyse, bu seçeneği tıklayın.\n\nDown Dog hesabı e-postanızın Google Fit ile senkronize edilen e-posta ile aynı olup olmadığını kontrol edin: aktivite izlemenin düzgün çalışması için bu ikisinin aynı olması gerekir.\n\nGoogle Fit günler öncesindeki uygulamaları gösteriyor ama en yenilerini göstermiyor mu? Eğer öyleyse, uygulamanızı kaydetmede bir gecikme olabilir, bazı kullanıcılar durumun böyle olduğunu bildirdi.\n\nEksik uygulamalar web istemcisinde / farklı bir cihazda yapılanlar mı? Maalesef, Google Fit'e giriş yapmayı yalnızca uygulama Android cihazda gerçekleştirildiğinde destekliyoruz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "Uygulamalar Google Fit'e bağlanıyor mu?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "Deneyebileceğiniz birkaç şey var!\n\n1) Ana yoga uygulamamız Down Dog veya Hamile Yogası uygulamasını kullanıyorsanız, <b> Odak </b> 'ınızı <b> Nefes </b> olarak ayarlayın! Bu size pratiğinizin başında bazı nefes egzersizleri ve sonunda rehberli bir meditasyon verecektir!\n\n2). Ana yoga uygulamamız Down Dog'u kullanıyorsanız Yoga Nidra'yı deneyin. Yoga Nidra'yı uygulama <b> Yazma </b> altında bulabilirsiniz, en alta kadar kaydırın. Not: <b> Yoga Nidra yalnızca sestir </b> - görüntü olmayacak. Birçok kişi uygulamada <b> Müzik </b> 'i Doğa Sesleri, Ortam, Beyin Dalgaları veya Piyano ve Yaylılar olarak ayarlamaktan hoşlanıyor ... birkaçını deneyin ve hangisini tercih ettiğinizi görün!\n\nYoga Nidra'da yeniyseniz, onu <b> Talimat Türü </b> <b> Tam Açıklama </b> veya <b> Varsayılan </b> olarak ayarlayarak dinlemenizi öneririz.\n\nYoga Nidra'yı uykuya dalmak için de kullanabilirsiniz. Egzersiz Türü olarak Yoga Nidra'yı seçtikten sonra, <b> Yükselt </b> seçeneğine gidin ve <b> Uyku </b> 'ya dokunun!\n\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "Uygulamamda nasıl daha fazla nefes çalışması ve rehberli meditasyon yapabilirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "Sağlık Sorumluluk Reddi ve Uyarı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co., yalnızca eğitim amaçlı tasarlanmış sağlık ve fitness bilgileri sunar. Yoga Buddhi Co. tarafından yapılan herhangi bir Uygulamadaki bilgilere (masaüstü, mobil ve cihaz Uygulamaları, web sitesi, bloglar ve Yoga Buddhi Co. veya Down Dog tarafından sağlanan sosyal medya sayfaları dahil ancak bunlarla sınırlı olmamak üzere) güvenmemelisiniz. profesyonel tıbbi tavsiye, teşhis veya tedavi için bir yedek. Herhangi bir Uygulamada bulunan herhangi bir içeriğin doğruluğunu, eksiksizliğini veya kullanışlılığını hiçbir şekilde garanti veya taahhüt etmiyoruz. Bu veya Yoga Buddhi Co. tarafından yapılan başka herhangi bir Uygulamada sağlanan herhangi bir bilginin kullanımının riski tamamen size aittir. Bu teknikleri uygularken maruz kalınan yaralanmalardan sorumlu değiliz ve Yoga Buddhi Co., yapılan herhangi bir Uygulamada sunulan herhangi bir faaliyet veya fikirle doğrudan veya dolaylı olarak meydana gelebilecek herhangi bir hasar, koşul, koşul veya yaralanmadan sorumlu tutulamaz Yoga Buddhi Co. tarafından Yoga yapmak yaralanma riski taşır. Hamileyseniz veya 18 yaşın altındaysanız uygun gözetim olmadan yoga egzersizlerini önermiyoruz. Herhangi bir Uygulamayı kullanarak, kendi sağlığınız veya sağlığınızı ve / veya bebeğinizin sağlığını veya sağlığını herhangi bir şekilde etkileyebilecek herhangi bir yaralanma veya aksilik ve sağlığınız için tüm sorumluluğu kabul etmiş olursunuz. Herhangi bir spor programına başlamadan önce veya sağlığınızla ilgili herhangi bir sorunuz veya endişeniz varsa doktorunuza veya sağlık uzmanınıza danışın. Doktorunuz veya sağlık uzmanınız buna karşı çıkarsa, bir fitness programına başlamayın. Egzersiz yaparken herhangi bir zamanda bayılma, baş dönmesi, ağrı veya nefes darlığı yaşarsanız, derhal durmalı ve acil tıbbi yardım almalısınız."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "Sağlık hizmeti sunanlar 1 Haziran 2022'ye kadar ücretsiz üyelik için uygundur!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "Sağlık Hizmeti Üyelikleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "İşte ayarlarınız!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "HIIT"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "Aralıklı Antrenman Egzersizi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "Tarih"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0} Saat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "Girişimizde toplam 9 ders var!\n \n<b> Tür </b> 'e dokunursanız, 3 kategoride Vinyasa, Hatha ve Restoratif görürsünüz.\n \nArdından, <b> Türünüzü </b> seçtikten sonra, ilgili dersi yapmak için sayıya (<b> 1, 2 veya 3 </b>) dokunun. Numaralı dersler birbirinin üzerine inşa edilecek şekilde tasarlanmıştır, bu nedenle önce 1'den başlamanızı öneririz. Daire beyaz bir arka plana sahipse, bu, seçilen Türün dersidir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "Kaç tane Giriş dersi var?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b> Aboneliğinizi Nasıl Yönetir veya İptal Edersiniz? </b>\n\n<em> Aboneliğinizi web üzerinden satın aldıysanız </em>:\n\n1. <b> Ayarlar </b> 'a gidin. Mobilde, ekranın sağ alt tarafındaki üç yatay çizgiye dokunarak oraya gidebilirsiniz. Web'de Ayarlar sol kenar çubuğundadır.\n2. <b> Ayarlar </b> altında, <b> Abonelik </b> 'e dokunun.\n3. Ardından, otomatik yenilemeyi kapatma dahil olmak üzere aboneliğinizi nasıl iptal edeceğiniz veya değiştireceğiniz dahil daha fazla bilgi görmelisiniz.\n\n<em> Aboneliğinizi mobil uygulama üzerinden satın aldıysanız </em>:\n\nAboneliğinizi <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store </a> veya <a href = \"https üzerinden yönetebilirsiniz : //support.google.com/googleplay/answer/7018481? co = GENIE.Platform% 3DAndroid & hl = tr \"target =\" _ blank \"> Google Play Store </a>.\n\n<b> Aboneliğiniz Hakkında </b>\n\nWeb sitemiz, Apple veya Google üzerinden açıkça bir üyelik satın almadığınız sürece hiçbir abonelik için ücret alınmayacaktır. Abonelikler, aboneliği satın alırken kullandığınız e-posta adresinin altında bulunur. Hesabınızda listelenen bir abonelik görmüyorsanız, şu anda oturum açmış olduğunuz e-posta adresiyle ilişkili bir aboneliğiniz olmadığı anlamına gelir. Aboneliğinizin başka bir e-posta adresiyle ilişkilendirilmiş olması mümkündür ve bu durumda, aboneliğinizi görmek için oturumu kapatıp o e-posta adresi altında tekrar oturum açmanız gerekecektir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "Aboneliğimi iptal etmek istiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "Katılıyorum"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "Farklı bir sorum var"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "( ) hakkında başka bir sorum var."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "Hala yardıma ihtiyacım var"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "Para iadesi istiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>Yoga</b> \n\nBeğenilen ve Hariç Tutulan pozlar özelliğimizle, belirli pozları \"beğenebilir\" ve bu da onların gelecekteki pratiklerde görünme olasılığını artırır. Tam ayarlarınızdan, <b>Pratik</b> altında, <b>Pozları Görüntüle</b>'ye dokunun. Buradan, pratiklerinizde daha fazla görmek istediğiniz pozları \"beğenebilirsiniz\".\n\n<b>Pozları Görüntüle</b>'den, pozları \"beğenmeme\" seçeneğini de kullanabilir ve bu pozlar herhangi bir gelecek pratikten hariç tutulur.\n\nLütfen Beğenilen ve Hariç Tutulan pozlar özelliğinin sadece yeni pratik türleri olan Vinyasa, Restoratif, Yin, Gentle ve Hatha için geçerli olduğunu unutmayın. Eski pratik türleri bu özelliği desteklememektedir.\n\nAyrıca, pozları beğenme/beğenmeme durumunun çeşitliliği etkileyeceğini de unutmayın.\n\n\n<b>HIIT</b> \n\nEvet! Pratik altında, <b>Karıştır</b>'a dokunun. Oradan, her vücut bölümünün solundaki + 'ya dokunun ve bir egzersiz listesi çıkacaktır. Pratiklerinizden hariç tutmak istediğiniz belirli egzersizlere dokunun.\n\n\n<b>Hamilelik Öncesi, Barre</b>\n\nBu özelliğimiz şu anda mevcut değil, ancak kesinlikle listemizde! Şimdilik, mobil uygulamada, hoşlanmadığınız herhangi bir pozu, karşınıza çıktığında sola kaydırarak atlayabilirsiniz. Web uygulamasında, ekranın sol altındaki ileri ok'a tıklayın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "Pratiğimde belirli pozları dahil edebilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "Instagram"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "Bu geçerli bir e-posta adresi gibi görünmüyor. Lütfen tekrar deneyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "Zaman çizelgesini görünür tutun"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "Dil"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "Son ödemeniz şuydu:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "Daha fazla bilgi edin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "Uzunluk"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "Az"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "Herkes farklı olduğu için, bir seviye yukarı çıkmayı deneyebilir ve bunun nasıl bir his olduğunu görebilirsiniz. Bazı günler bir seviyeye inmek isteyebilir, diğer günler yeni bir şeyler denemek isteyebilir! En önemlisi, vücudunuzun size verdiği geribildirimi dinleyin ve yavaş ve kontrollü hareket edin.\n\nUygulamadaki <b> Ayarlar </b> sayfasından erişilebilen <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\"> Facebook Topluluğu </a>, uygulamayı kullanan diğer kişilerden tavsiye almak için harika bir kaynaktır!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "Ne zaman bir seviye yukarı çıkmalıyım?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "Ömür boyu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "Hayır. Şu anda böyle bir hizmetimiz yok."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "Ömür boyu abonelik satın alabilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "Beğen"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "Gelecekteki pratiklerinizi geliştirmek için pozları beğenin veya beğenmeyin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} Beğenildi, ${p1} Beğenilmedi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = "Ekran medya kontrollerini kilitle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "Oturum Aç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "${p0} olarak giriş yaptınız."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "Giriş Hatası"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "Çıkış Yap"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "İnternete bağlı görünmüyorsunuz. Hesap değiştirmek için lütfen yeniden bağlanın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "Öğrenci veya öğretmenseniz, ${p0} sayfamıza bir göz atın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "<b> Daha Fazla </b> seçeneğine ve ardından <b> Görsel Türü </b> seçeneğine dokunarak farklı görsel türleri arasında geçiş yapabilirsiniz. Daha yüksek ve daha düşük kaliteli video için seçenekler görmelisiniz. Bu ayar yalnızca yoga uygulamalarında mevcuttur."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "Videolar telefonumun depolama alanını çok fazla kaplıyor."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "Her seçenek için oy verdiğinizden emin olun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "Çok fazla e-posta göndermemeye çalışıyoruz, ancak lütfen e-postaların topluluğumuza özel satışlar ve yeni özellikler hakkında bilgi vermemizin birincil yolu olduğunu unutmayın!\n\nE-postalarımıza abone olup olmadığınızı, <b> Ayarlar </b> 'a gidip ardından <b> Promosyon E-postaları Al </b> seçeneğine gidip açıp kapatarak kontrol edebilirsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "E-posta tercihlerimi nasıl yönetirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "Ayarlar görünümünü yukarı kaydırıp ardından <b> Talimat </b> 'a dokunarak konuşma miktarını artırabilirsiniz. Sunduğumuz en fazla talimat miktarını almak için <b> Tam Açıklama </b> 'ya dokunun.\n\nBu ayar yalnızca yoga uygulamalarımızda mevcuttur. HIIT, Bar ve 7-Dakikalık Antrenman'da konuşma miktarını değiştiremezsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "Poz verirken mümkün olan en fazla talimatı duymak istiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "Meditasyon"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "Meditasyon Pratiği"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "Hayır. Abonelikler, satın alır almaz başlar.\n\nÜcretsiz deneme süresindeyseniz, satın almak için deneme bitene kadar beklemek isteyebilirsiniz, ancak özel bir satış yapıyorsak, bu en iyi fiyatı kaçırmak anlamına gelebilir - bunun zor bir karar olabileceğini biliyoruz. !\n\nÖzel bir indirim yapsak da yapmasak da, web sitemiz genellikle o sırada en iyi fiyatı sunar, bu nedenle, siz satın almaya hazır!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "Abonelik başlangıç tarihimi erteleyebilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "Menü"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "Ayarlar görünümünü yukarı kaydırıp ardından <b> Talimat </b> 'a dokunarak konuşma miktarını azaltabilirsiniz. Sunduğumuz en az talimat miktarını almak için <b> En Az Açıklama artı Sessizlik </b> seçeneğine dokunun.\n\nBu ayar yalnızca yoga uygulamalarımızda mevcuttur. HIIT, Bar ve 7-Dakikalık Antrenman'da konuşma miktarını değiştiremezsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "Zen zihnine geçmek ve mümkün olan en az miktarda talimat duymak istiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0} Dakika"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0} dakika"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "dakika"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "Yansıtma Videosu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "Down Dog, Sağlık uygulamasına kaynak olarak eklendi. Ancak, günlük tutma uygulamalarına başlamak için Sağlık uygulamasından Down Dog için Workouts iznini etkinleştirmeniz gerekecektir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "Mix"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "Pazartesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "ay"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "Aylık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "Aylık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "Aylık pratikler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "${p0} kez"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "Pratik yaptığın Aylık süre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "Zaten aylık bir abonelik satın aldıysanız, ancak bunun yerine yıllık aboneliği tercih ediyorsanız, mevcut satın alma işleminizi nasıl yaptığınıza bağlı olarak birkaç adım atmanız gerekecektir.\n\n<em> <b> Web sitemiz </b> veya <b> Google Play </b> </em> aracılığıyla satın aldıysanız:\n\nMevcut aboneliğinizi web üzerinden satın aldıysanız, mevcut aboneliğinizi iptal etmek için <b> Ayarlar </b> 'a ve ardından <b> Abonelikler </b>' e gidin. Google Play üzerinden satın aldıysanız, mevcut aboneliğinizi <a href = \"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=tr\" target = \"_ boş yoluyla iptal edebilirsiniz. \"> Google Play Store </a>. Mevcut aboneliğinizi iptal ettikten sonra, <a href=\"/purchase\"> web sitemizden yeni bir abonelik satın alabilirsiniz </a>.\n\nLütfen, iptal edip yeniden satın almayı seçerseniz, size kısmi bir geri ödeme teklif edemeyeceğimizi unutmayın. Bazı sınırlı durumlarda, mevcut satın alma işleminizin geri ödemesini almaya hak kazanabilirsiniz - <a href=\"/support\"> Destek </a> adresinde \"Geri ödeme istiyorum\" seçeneğine tıklayarak geri ödeme uygunluğunuzu kontrol edebilirsiniz. Geri ödeme için uygunsanız ve <a href=\"/support\"> Destek </a> adresinde \"Geri ödeme istiyorum\" bölümünde başarılı bir şekilde geri ödeme talebinde bulunduysanız ve geri ödeme onayını aldıysanız, mevcut aboneliğiniz otomatik olarak iptal edilir. Ardından <a href=\"/purchase\"> web sitemiz üzerinden yeni bir abonelik satın alabilirsiniz </a>.\n\n<em> Aboneliğinizi <b>Apple</b> </em> aracılığıyla satın aldıysanız:\n\nAboneliğinizi <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store </a> üzerinden iptal etmeniz gerekecek. Apple aracılığıyla yapılan satın alımlara ilişkin iade taleplerini karşılayamadığımızı lütfen unutmayın. Mevcut aboneliğinizi Apple üzerinden iptal ettikten sonra, genellikle en iyi fiyata sahip olan <a href=\"/purchase\"> web sitemizden yeni bir abonelik satın alabilirsiniz </a>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "Aylık abonelik satın aldım ancak yıllık aboneliğe geçmek istiyorum."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "Daha Fazla"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "Müzik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "Bir uygulamaya başladıktan sonra, ekrana dokunur ve uygulamanızı duraklatırsanız, <b> Müzik / Ses karıştırma kaydırıcısını </b> kullanarak müzik ve ses seviyesini ayarlayabilirsiniz.\n\nTercih ettiğiniz Müzik / Ses oranını ayarladıktan sonra, genel ses seviyesini artırmak veya azaltmak için cihazınızı kullanabilirsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "Öğretmenin sesini duyamıyorum! Ses kontrolü nerede?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "Bilgilerim"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "Aaa! Bu şarkının ön izlemesini çalmak için internete bağlı olmanız gerekir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "Yeni Şifre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "Sonraki"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "Sonraki Ödeme"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "Sonraki Ödeme: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "Yoga Nidra <b> yalnızca sestir </b> - video olmayacak!\n\nYoga Nidra, derinlemesine rahatlatıcı, rehberli bir meditasyondur. Pratikte <b> Tür </b> altında bulabilirsiniz, sonuna kadar kaydırın. Birçok kişi uygulamada <b> Müzik </b> 'i Doğa Sesleri, Ortam, Beyin Dalgaları veya Piyano ve Yaylılar olarak ayarlamaktan hoşlanıyor ... birkaçını deneyin ve hangisini tercih ettiğinizi görün!\n\nYoga Nidra'da yeniyseniz, onu <b> Talimat Türü </b> <b> Tam Açıklama </b> veya <b> Varsayılan </b> olarak ayarlayarak dinlemenizi öneririz. Yoga Nidra'yı uykuya dalmak için de kullanabilirsiniz.\n\nEgzersiz Türü olarak Yoga Nidra'yı seçtikten sonra, <b> Artırın </b> ve <b> Uyku </b> 'ya dokunun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "Yoga Nidra pratiğimde video yok."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "Herhangi bir değişim veya dönüştürme ücreti almıyoruz, ancak bankanız alabilir, bu nedenle bunları kontrol ettiğinizden emin olun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "Değişim ücreti alıyor musunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "Facebook ile oturum açmak için lütfen e-posta adresinize erişime izin verin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "Henüz herhangi bir pratiği tamamlamış gibi görünmüyorsun. İlk pratiğinizebaşlamak için ana ekrana geri kaydırın!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "Sunucularımızla iletişim kurmakta sorun yaşıyoruz. Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "Lisans kısıtlamaları nedeniyle, çevrimdışıysanız kaydedilen favorilerimize müziğimiz eşlik etmeyecektir.\n\nKendi müziğinizi çalmak isterseniz, bunu cihazınızdaki diğer uygulamalar aracılığıyla yapabilirsiniz. Bununla birlikte, ses ipuçları telefonlarda ve tabletlerde varsayılan olarak maksimum ses düzeyine getirilirken, bazen bu, Spotify / iTunes / vb.\n\nBu durumlarda, müzik çalmak için harici bir hoparlör kullanmanızı veya bir dizüstü bilgisayarda veya masaüstünde <a href=\"/web\"> downdogapp.com/web </a> web sürümünü müziğiniz kapalıyken kullanmanızı öneririz. arkaplan.\n\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "Çevrimdışıyım ve kayıtlı favori pratiğimde müzik yok."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "Henüz herhangi bir uygulama indirmediniz. Uygulamaları geçmişinizden indirebilir veya buradan yeni bir tane oluşturabilirsiniz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "Maalesef, kısmi veya orantılı geri ödeme taleplerini karşılayamıyoruz.\n\nZaten bir abonelik satın aldıysanız, ancak farklı bir abonelik istiyorsanız, mevcut satın alma işleminizi nasıl yaptığınıza bağlı olarak birkaç adım atmanız gerekecektir.\n\n<em> <b> Web sitemiz </b> veya <b> Google Play </b> </em> aracılığıyla satın aldıysanız:\n\nMevcut aboneliğinizi web üzerinden satın aldıysanız, mevcut aboneliğinizi iptal etmek için <b> Ayarlar </b> 'a ve ardından <b> Abonelikler </b>' e gidin. Google Play üzerinden satın aldıysanız, mevcut aboneliğinizi <a href = \"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=tr\" target = \"_ boş yoluyla iptal edebilirsiniz. \"> Google Play Store </a>. Mevcut aboneliğinizi iptal ettikten sonra, <a href=\"/purchase\"> web sitemizden yeni bir abonelik satın alabilirsiniz </a>.\n\nLütfen, iptal edip yeniden satın almayı seçerseniz, size kısmi bir geri ödeme teklif edemeyeceğimizi unutmayın. Bazı sınırlı durumlarda, mevcut satın alma işleminizin geri ödemesini almaya hak kazanabilirsiniz - <a href=\"/support\"> Destek </a> adresinde \"Geri ödeme istiyorum\" seçeneğine tıklayarak geri ödeme uygunluğunuzu kontrol edebilirsiniz. Geri ödeme için uygunsanız ve <a href=\"/support\"> Destek </a> adresinde \"Geri ödeme istiyorum\" bölümünde başarılı bir şekilde geri ödeme talebinde bulunduysanız ve geri ödeme onayını aldıysanız, mevcut aboneliğiniz otomatik olarak iptal edilir. Ardından <a href=\"/purchase\"> web sitemiz üzerinden yeni bir abonelik satın alabilirsiniz </a>.\n\n<em> Aboneliğinizi <b>Apple</b> </em> aracılığıyla satın aldıysanız:\n\nAboneliğinizi <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store </a> üzerinden iptal etmeniz gerekecek. Apple aracılığıyla yapılan satın alımlara ilişkin iade taleplerini karşılayamadığımızı lütfen unutmayın. Mevcut aboneliğinizi Apple üzerinden iptal ettikten sonra, genellikle en iyi fiyata sahip olan <a href=\"/purchase\"> web sitemizden yeni bir abonelik satın alabilirsiniz </a>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "Kısmi geri ödeme alabilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "Geçmiş Satın Alma Yok"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "Görünüşe göre daha önce herhangi bir satın alma yapmamışsınız. Bunun bir hata olduğunu düşünüyorsanız lütfen bizimle iletişime geçin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "Satın aldıktan sonra bir pratiği tamamladığınız için bu ödeme iade edilemez."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "Bu ödeme, ${p0} günden uzun bir süre önce gerçekleştiğinden geri ödenemez."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "En sevdiğiniz pratikleri daha sonra tekrar oynatmak için kaydedin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "Uygulamadan ses almak için atabileceğiniz bazı adımlar şunlardır:\n\n• Cihazınızın sesinin kapatılmadığından emin oldunuz mu? Bunu, farklı bir uygulama üzerinden müzik veya ses çalarak kontrol edebilirsiniz.\n• Uygulama içi sesin açık olup olmadığını kontrol ettiniz mi? Bir uygulamaya başladıktan sonra, alıştırmanızı duraklatıp ardından ekranın alt kısmına yakın kaydırıcıyı ayarlayarak müzik ve ses seviyesi arasındaki dengeyi ayarlayabilirsiniz. Hem müziği hem de sesi duymak için ortaya yakın ayarlandığından emin olun!\n• Uygulamayı kapatıp yeniden açmayı denediniz mi?\n• Uygulamayı kaldırıp yeniden yüklemeyi denediniz mi?\n• Down Dog'un web sürümünü kullanmayı denediniz mi (<a href=\"https://www.downdogapp.com/web\" target=\"_blank\"> https://www.downdogapp.com/web </a> ) aynı sorunun olup olmadığını görmek için?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "Bende ses yok."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "Hayır"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "Savaşçı 1 ve Güvercin gibi asimetrik pozları atlayın (endişelenmeyin, kalça açıcılarınızı hala tutuyoruz!)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "Yok"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "Eylül 2018'de, insanlara tüm özelliklere tam erişim sağlayan kısa bir ücretsiz deneme sunduğumuz ve bundan sonra bir abonelik gerekli olduğu yeni bir fiyatlandırma modeline geçtik. Bu fiyatlandırma modeli tüm uygulamalarımıza uygulanır.\n\n<b> Satın Alma Yöntemleri </b>\n\n<a href=\"/purchase\"> Web sitemiz üzerinden satın alma </a> genellikle size en iyi fiyatı verir! Web sitemizden bir <b> kredi kartı </b> veya <b> PayPal </b> ile satın alabilirsiniz. Web sitemiz üzerinden satın almak, tıpkı Apple veya Google aracılığıyla uygulama içi satın almışsınız gibi, tüm uygulamalardaki her şeye erişmenizi sağlar.\n\nUygulama içi olarak Apple veya Google üzerinden de satın alabilirsiniz. Apple ve Google'ın komisyon ücreti aldığını lütfen unutmayın, bu nedenle uygulama içi fiyat genellikle web sitemizdekinden daha yüksek olacaktır.\n\n* Amerika Birleşik Devletleri dışında yapılan satın alma işlemleri için herhangi bir döviz kuru ücreti almıyoruz, ancak bankanız alabilir, bu nedenle bunları kontrol ettiğinizden emin olun!\n\nYakın zamanda işsizlik, evsizlik veya ciddi sağlık veya öğrenci borcu yaşıyorsanız, lütfen durumunuzu açıklayarak <a href=\"/affordability\"> https://www.downdogapp.com/affordability </a> adresinden bize yazın. ve yardım etmek için elimizden geleni yapacağız!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "Uygulamanın ücretsiz olduğunu düşündüm, neden bir abonelik satın almam isteniyor?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "Tamam"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "Yalnızca 1}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "Amazon'da Aç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "İTunes'da Aç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "Spotify'da Aç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "${p0} ile aç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "Bağlantıyı Aç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "${p1} 'den ${p0} seçeneği"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "veya"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "Diğer"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "Diğer Uygulamalar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "Hız"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "Şifre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "Şifreniz en az dört karakter uzunluğunda olmalıdır."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "Şifreler Uymalı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "Duraklat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "ile Öde"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "PayPal ile Öde"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "PayPal satın alma işleminizi onaylarken bir hata oluştu. Lütfen birkaç dakika sonra tekrar deneyin veya müşteri desteği ile iletişime geçin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "Bu ödeme zaten iade edildi."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "Ödeme Onaylandı!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "İşte bir abonelik satın almanın yolları!\n\n1) Bir <b> kredi kartıyla </b> veya <b> PayPal </b> ile <a href=\"/purchase\"> <b> web sitemizden satın alabilirsiniz </b> </a>.\n\nWeb sitemiz üzerinden satın almak, tıpkı Apple veya Google aracılığıyla uygulama içi satın almışsınız gibi, tüm uygulamalardaki her şeye erişmenizi sağlar. Web sitemizdeki fiyat genellikle en iyi fiyattır çünkü dahil edilen Apple / Google komisyon ücretleri yoktur.\n\n2) Apple veya Google üzerinden uygulama içi satın alabilirsiniz.\n\nApple ve Google'ın komisyon ücreti aldığını lütfen unutmayın, bu nedenle uygulama içi fiyat genellikle web sitemizdekinden daha yüksek olacaktır.\n\n* Amerika Birleşik Devletleri dışında yapılan satın alma işlemleri için herhangi bir döviz kuru ücreti almıyoruz, ancak bankanız alabilir, bu nedenle bunları kontrol ettiğinizden emin olun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "Hangi ödeme yöntemlerini kabul ediyorsunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "Plan"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "Aylık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "Yıllık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "pilates"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "Pilates Egzersizi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "Oynat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "Play Store'dan ürün fiyatları alınırken hata oluştu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "Oynatma Listesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "Oynatma listesi türünüzü değiştirirken sorun yaşadık. Birkaç saniye sonra tekrar deneyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "İnternete bağlı görünmüyorsun. Müzik türlerini değiştirmek için lütfen yeniden bağlanın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "Gelecek pratiklerinizden ${p0} 'i çıkaracağız"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "Şu anda bir poz kitaplığı sunmuyoruz, ancak geliştirme aşamasında! Bizi izlemeye devam edin!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "Her poz hakkında daha fazla bilgi edinebilmem için bir poz kitaplığı sunuyor musunuz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "Gelecek pratiklerinize daha fazla ${p0} ekleyeceğiz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "Poz Listesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "Aşağıdaki tüm pozları keşfedin ve hangilerini gelecekteki pratiklerinizde daha çok veya daha az görmek istediğinizi belirleyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "Poz İsimleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "Pozlar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "Pratik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "Pratik Geri Bildirimi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "Pratik Sık Kullanılanlar'a eklendi!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "Antrenman serisi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "${p0} Pratikler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "Hamile Yogası"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "Evet! Kontrol etmeniz gereken bağımsız bir HamileYogası uygulamamız var! Hamile Yogası'nı <a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal\" target=\"_blank\"> Android </a> ve <a href = \"https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442\" target = \"_ blank\"> iOS </a> veya <a href = \"https: // prenatal .downdogapp.com / web \"target =\" _ blank \"> prenatal.downdogapp.com/web </a>. Bu uygulama, pratiğinizi üç aylık döneme göre özelleştirmenize izin verecektir. Ayrıca, ana yoga uygulamamızın sunduğu pek çok iyileştirmenin yanı sıra hamileliğe özgü bazı özel özelliklere sahiptir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "Hamileyim! Seçebileceğim doğum öncesi bir seçenek var mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "Hamile"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "Video hazırlanıyor... %${p0} Tamamlandı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "Videonuzu hazırlıyoruz. Lütfen indirme başlayana kadar uygulamayı açık tutun veya indirmeyi başlatmak için birkaç dakika içinde uygulamaya dönün."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\"> Web sitemiz üzerinden satın alma </a>, Apple veya Google tarafından yaygın olarak alınan komisyon ücretlerinden kaçınır ve genellikle size en iyi fiyatı verir! Web sitemizden bir <b> kredi kartı </b> veya <b> PayPal </b> ile satın alabilirsiniz. Web sitemiz üzerinden satın almak, tıpkı Apple veya Google aracılığıyla uygulama içi satın almışsınız gibi, tüm uygulamalardaki her şeye erişmenizi sağlar. Bilgisayarınızda, telefonunuzda ve tabletinizde bir web aboneliği kullanabilirsiniz.\n\nAyrıca Apple veya Google aracılığıyla uygulama içi bir abonelik satın alabilirsiniz. Apple ve Google'ın komisyon ücreti aldığını lütfen unutmayın, bu nedenle uygulama içi fiyat genellikle web sitemizdekinden daha yüksek olacaktır.\n\n* Amerika Birleşik Devletleri dışında yapılan satın alma işlemleri için herhangi bir döviz kuru ücreti almıyoruz, ancak bankanız olabilir, bu nedenle bunları kontrol ettiğinizden emin olun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "Uygulama içi fiyatlar web fiyatlarından neden farklı? Üyelikler farklı mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "Gizlilik Politikası"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "Promosyon E-postaları Alın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "${p0} adresine bir makbuz gönderilecektir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "Bir abonelik satın aldıktan sonra, aboneliğinizle ilişkili e-posta adresine bir makbuz göndeririz.\n\nMaalesef makbuzlar yeniden gönderilemez. Orijinal makbuzu bulmanız gerekiyorsa, e-postanızda \"<b> DOWN DOG FİŞİNİZ </b>\" konu satırını aramanızı öneririz. Spam klasörünüzü kontrol ettiğinizden emin olun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "Abonelik satın alma işlemim için bana bir makbuz gönderebilir misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "Kullan"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "Aşağıdaki butona tıklayarak Down Dog'a 1 yıllık ücretsiz erişim hakkınızı talep edin! Hediye (kod ${p0}), hediyeyi kullandığınız günden itibaren ${p1} hesabınıza yüklenecektir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "Down Dog Hediye Kartınızı Kullanın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "Aboneliğinizi web üzerinden satın aldıysanız, <a href=\"/support\"> destek </a> sayfamız aracılığıyla geri ödeme talebinde bulunabilirsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "Nasıl para iadesi alabilirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "Geri ödemeniz yolda."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "Favorilerden Çıkar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "Geçmişten Kaldır "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "Bu pratiği geçmişinden kaldırmak istediğine emin misin?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "Evet! <b> Favoriler </b> ekranında, <b> Adı Düzenle </b> 'ye dokunun ve istediğinizi yazabilirsiniz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "Hangisinin hangisi olduğunu unutmamak için favori uygulamalarımı adlandırabilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "Lütfen ${p0} alan adına sahip bir e-posta adresi kullanarak giriş yapın!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "Sıfırla"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "Şifrenizi sıfırlamak için bir bağlantı şu adrese gönderildi: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "Pratiğe Devam Et"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "Önceki pratiğinize devam etmek ister misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "Koşu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "Down Dog Koşu Antrenmanı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "Telefonda veya tablette en iyi deneyim için uygulamayı App Store veya Play Store'dan indirin. Bir masaüstü / dizüstü bilgisayarda, en güvenilir oynatma için Chrome'u kullanın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "Ne zaman bir satış yapsak, indirimli fiyatı almak için <a href=\"/purchase\"> downdogapp.com/purchase </a> adresindeki web sitemiz üzerinden satın almalısınız.\n\nWeb sitemiz üzerinden kredi kartı veya PayPal kullanılarak satın alma yapılabilir. Uluslararası işlemler için döviz ücreti almayız, ancak bankanız alabilir, bu nedenle bunları kontrol ettiğinizden emin olun!\n\nZaten bir abonelik satın aldıysanız ve yaptığımız özel bir satıştan yararlanmak istiyorsanız, mevcut satın alma işleminizi nasıl yaptığınıza bağlı olarak birkaç adım atmanız gerekecektir.\n\n<em> <b> Web sitemiz </b> veya <b> Google Play </b> </em> aracılığıyla satın aldıysanız:\n\nMevcut aboneliğinizi web üzerinden satın aldıysanız, mevcut aboneliğinizi iptal etmek için <b> Ayarlar </b> 'a ve ardından <b> Abonelikler </b>' e gidin. Google Play üzerinden satın aldıysanız, mevcut aboneliğinizi <a href = \"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=tr\" target = \"_ boş yoluyla iptal edebilirsiniz. \"> Google Play Store </a>. Mevcut aboneliğinizi iptal ettikten sonra, <a href=\"/purchase\"> web sitemizden yeni bir abonelik satın alabilirsiniz </a>.\n\nLütfen, iptal edip yeniden satın almayı seçerseniz, size kısmi bir geri ödeme teklif edemeyeceğimizi unutmayın. Bazı sınırlı durumlarda, mevcut satın alma işleminizin geri ödemesini almaya hak kazanabilirsiniz - <a href=\"/support\"> Destek </a> adresinde \"Geri ödeme istiyorum\" seçeneğine tıklayarak geri ödeme uygunluğunuzu kontrol edebilirsiniz. Geri ödeme için uygunsanız ve <a href=\"/support\"> Destek </a> adresinde \"Geri ödeme istiyorum\" bölümünde başarılı bir şekilde geri ödeme talebinde bulunduysanız ve geri ödeme onayını aldıysanız, mevcut aboneliğiniz otomatik olarak iptal edilir. Ardından <a href=\"/purchase\"> web sitemiz üzerinden yeni bir abonelik satın alabilirsiniz </a>.\n\n<em> Aboneliğinizi <b>Apple</b> </em> aracılığıyla satın aldıysanız:\n\nAboneliğinizi <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store </a> üzerinden iptal etmeniz gerekecek. Apple aracılığıyla yapılan satın alımlara ilişkin iade taleplerini karşılayamadığımızı lütfen unutmayın. Mevcut aboneliğinizi Apple üzerinden iptal ettikten sonra, genellikle en iyi fiyata sahip olan <a href=\"/purchase\"> web sitemizden</a> yeni bir abonelik satın alabilirsiniz!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "Bir satışla ilgili bir e-posta aldım! Satış fiyatını nasıl alırım?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "Sanskritçe poz isimleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "Kaydet"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "Kaydet ve Bağlantıyı Kaldır"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "Evet! Çevrimdışı kullanım için bir muayenehaneyi kaydetmenin üç yolu vardır. Bunun yalnızca mobil uygulamalarda çalıştığını, web'de çalışmadığını unutmayın.\n \n1. <b> Sık Kullanılanlar </b> ekranından bir uygulama oluşturun ve kaydedin. Oraya gitmek için, Başlangıç ekranının altındaki kalp simgesine dokunun). <b> Favoriler </b> sayfasında, <b> Yeni Pratiği İndir </b> yazan büyük mavi bir düğme göreceksiniz. Buna dokunun ve mevcut ayarlarınızla (geldiğiniz yerde ana ekranda görebileceğiniz) bir uygulamayı otomatik olarak indirirsiniz. Uygulama adının sağ tarafında, cihazınıza kaydedildiğini gösteren bir aşağı ok olduğundan emin olun.\n \n2. <b> Geçmişinizden </b> bir uygulamayı kaydedin. Oraya gitmek için, <b> Geçmiş </b> sayfasına gidin (Başlangıç ekranının altındaki saat simgesine dokunun). Aşağı kaydırın ve kaydetmek istediğiniz uygulamaya dokunun. Altta <b> Sık Kullanılanlara Ekle </b> kelimelerini göreceksiniz. Çevrimdışı kullanım için uygulamayı <b> Sık Kullanılanlara </b> kaydedecek olan düğmeye basmak (ekranınızın altındaki kalp simgesine dokunarak uygulamanın <b> Sık Kullanılanlar </b> listenize kaydedilip kaydedilmediğini kontrol edebilirsiniz). Uygulama adının sağ tarafında, cihazınıza kaydedildiğini gösteren bir aşağı ok olduğundan emin olun.\n \n3. Uygulamanızın sonunda, <b> Sık Kullanılanlara Ekle </b> seçeneğine basın. Buna basmak, az önce yaptığınız uygulamayı <b> Favoriler </b> sayfasına kaydedecektir (alttaki kalp simgesi). Uygulama adının sağ tarafında, cihazınıza kaydedildiğini gösteren bir aşağı ok olduğundan emin olun.\n\nLisans kısıtlamaları nedeniyle, çevrimdışıyken müziğimizin kaydedilen favorilere eşlik etmeyeceğini lütfen unutmayın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "Down Dog'u çevrimdışı kullanabilir miyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "Mobil uygulamada bir uygulamayı kaydetmenin iki yolu vardır:\n\n1. <b> Geçmiş </b> sayfanıza gidin (Başlangıç ekranının altındaki saat simgesine dokunun). Oradayken, aşağı kaydırın ve ardından kaydetmek istediğiniz uygulamaya dokunun. Altta <b> Sık Kullanılanlara Ekle </b> kelimelerini göreceksiniz. Buna basmak, uygulamayı <b> Favoriler </b> sayfasına (ekranınızın altındaki kalp simgesi) kaydedecektir.\n\n2. Bir uygulamayı bitirdikten sonra, <b> Sık Kullanılanlara Ekle </b> 'ye dokunun ve bunu <b> Sık Kullanılanlar </b> sayfanıza (ekranınızın altındaki kalp simgesi) kaydedecektir.\n\nWeb uygulamasında:\n\n1. Bir uygulamayı bitirdikten sonra, <b> Sık Kullanılanlara Ekle </b> 'ye dokunun ve sol kenar çubuğunda bulunan <b> Sık Kullanılanlar </b> sayfanıza kaydedecektir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "En sevdiğim pratikleri kaydetmenin bir yolu var mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "Okul Üyelikleri"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "Puan"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1 (Nefret ettim)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5 (Sevdim)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "Ara"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "Bir poz arayın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "Bir egzersiz arayın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "Zaman çizelgesindeki alıştırmaları görün"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "Zaman çizelgesindeki pozları görün"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "Seç"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "Gönder"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "Geribildirim Yolla"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "Geri bildirim gönderilemedi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "Üzgünüz, mevcut ayarlarınızla bu alıştırma süresi mümkün değil. Lütfen başka bir uzunluk seçin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "Şifre Belirle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "Ayarlar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b> HIIT ve Barre: </b> \n\nVarsayılan ayarlarımız başlamak için harika bir yerdir! \n\nHIIT Seviye 1'de çok zorsa, Seviye 0'ı deneyin! Ayrıca her egzersiz için daha kısa zaman harcamayı deneyebilirsiniz. Bunu, Egzersiz Sürenizi ayarlayabileceğiniz Alıştırma altındaki ayarlarınızı düzenleyerek düzenleyebilirsiniz. 5 veya 10 saniyenin ne kadar büyük bir fark yaratabileceğine şaşıracaksınız! Ayrıca, genel antrenmanınızın uzunluğunu azaltabilir ve egzersizler arasında her Toparlanma süresini artırabilirsiniz. \n\nBarre için, antrenmanınızın uzunluğunu değiştirerek zorluğu ayarlayabilirsiniz. Deneyimli sporcular 15 veya 20 dakika ile başlamalı ve ek bir mücadele istiyorlarsa yollarına devam etmelidir. Yeni başlayan biriyseniz, her gün sadece 5 dakika veya her gün 10 dakika ile başlamak isteyebilirsiniz. Devam edin ve kısa sürede daha uzun antrenmanlara hazır olacaksınız!\n\n <b> Yoga: </b> \n\nYogada yeniyseniz, Alıştırma ayarlarının altında bulunan Seviye <b> Başlangıç 1 </b> ile başlamanızı öneririz. \n\nHuzurlu bir uygulama için, pozlarda en uzun süre tutmaya izin verecek olan <b> Nazik </b>, <b> Yin </b> veya <b> Restoratif </b> ile başlamanızı öneririz. \n\nDaha hızlı, daha enerjik bir uygulama için, bunun yerine <b> Tam Uygulama </b> veya <b> Hatha (Akış Yok) </b> ile başlamanızı öneririz. En ayrıntılı talimatları almak için <b> Talimat </b> seviyenizi <b> Tam Açıklama </b> olarak ayarlayın.\n\n<b> Hamile Yogası: </b> \n\nYogada yeniyseniz, Alıştırma ayarlarının altında bulunan Seviye <b> Başlangıç 1 </b> ile başlamanızı öneririz. \n\nHuzurlu bir uygulama için, tamamen zemin çalışması olan ve pozlarda en uzun tutmaya izin verecek olan <b> Restoratif </b> ile başlamanızı öneririz. \n\n<b> Meditasyon: </b> \n\nMeditasyonda yeniyseniz, <b> En Uzun Sessizlik </b> 'inizi oldukça kısa tutmanızı öneririz - varsayılan süre 2 dakikadır, ancak daha azına sahip olmayı tercih ederseniz, 30 saniyeye kadar kısaltabilirsiniz. sessizlik ve daha fazla rehberlik. Ayrıca sunduğumuz en fazla talimatı almak için <b> Rehberlik Miktarınızı </b> <b> En Fazla </b> olarak ayarlayabilirsiniz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "Nereden başlayacağımı bilmiyorum! En iyi deneyimi elde etmek için hangi ayarları seçmeliyim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7 Dakika"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "Paylaş"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "Uygulamanızı tamamladıktan sonra veya <b> Geçmiş </b> veya <b> Favorilerinizden </b>, bu uygulamayı arkadaşlarınızla paylaşmak için bir bağlantı almak için <b> Bu Uygulamayı Paylaşın </b> 'a dokunun.\n\nArkadaşlarınız bağlantıya tıkladıklarında, uygulamaya yönlendirilecekler ve kaydedilen uygulama hakkında bir açılır mesaj alacaklar. <b> Sık Kullanılanlarına </b> kaydedildiğinden emin olmak için <b> Evet </b> 'e dokunmaları gerekir!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "Arkadaşlarımla bir uygulamayı nasıl paylaşabilirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "Bu Pratiği Paylaşın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "Paylaşılan Pratik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "Egzersiz İsimlerini Göster"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "Beğen ve Hariç Tut Düğmelerini Göster veya Gizle Seçeneği"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "'Sıradaki' Metnini Göster"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "Poz Adlarını Göster"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "Altyazıları Göster"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "Kaydol"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "Kayıt Ol / Giriş yap"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "Atla"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b> Yoga ve Doğum Öncesi: </b>\n\nHer pozda en çok zaman geçirmek için <b> Hızınızı </b> <b> En Yavaş </b> olarak ayarlayın. En fazla talimatı ve işaretçileri almak için, <b> Talimat </b> seviyenizi <b> Tam Açıklama </b> olarak da ayarlayabilirsiniz.\n\nAyrıca vinyasa akışlarını / chaturangaları dışarıda bırakmak için, uygulamanızı Tam Uygulama yerine <b> Hatha (Akış Yok) </b> olarak ayarlamayı deneyebilirsiniz. Veya işleri daha da yavaşlatmak istiyorsanız, uygulamanızı <b> Nazik </b> veya <b> Yin </b> veya <b> Sandalye </ b>, ya da <b> Restoratif</b> olarak ayarlayın!\n\n<b> HIIT: </b>\n\nHer egzersiz için harcanan zamanı değiştirebilirsiniz. Ayalrlar görünümünü yukarı kaydırın ve <b>Pratik</b> 'in altında, <b> Egzersiz Uzunluğu </b> seçeneğine dokunun. Ayrıca, egzersizler arasındaki dinlenme süresini <b> Kurtarma </b> seçeneğine dokunarak da ayarlayabilirsiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "Pratiğimin hızını nasıl yavaşlatabilirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "Sosyal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "Bir şeyler yanlış gitti"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "Şarkı listesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "Çalınan Şarkılar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "Başlat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "Çalışmaya Başlayın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "İnternete bağlı görünmüyorsun. Yeni bir pratik başlatmak için lütfen yeniden bağlanın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "Bu ortak uygulamaya başlamak ister misiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "Ne görmek istersin?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "Statünüzü seçin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "Öğrenciler ve öğretmenler 1 Haziran 2022'ye kadar ücretsiz üyelik için uygundur!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "Konu:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "Gönder"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "Gönderiliyor ..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "Abonelik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "Otomatik yenilemeye giderseniz, o zaman evet! Otomatik yenilemeyi kapatırsanız, yeniden abone olmaya hazır olduğunuzda mevcut fiyattan yeniden abone olabilirsiniz. Paypal ile yapılan işlemlerde, otomatik yenilemeyi kapattıktan sonra tekrar açamayacağınızı lütfen unutmayın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "Aboneliğim satın aldığım fiyatla yenilenir mi?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "${p0} olarak giriş yaptınız. Hesabınızdaki abonelikler şunlardır:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "Sunduğumuz her dil için kapalı alt yazılar / alt yazılar mevcuttur!\n\nMobil uygulamada:\n1. Bir uygulama başlatın\n2. Çeviri yazıları açmak için ekranınızın sağ üst köşesinde bulunan <b> cc </b> simgesine dokunun\n\nWeb uygulamasında:\n1. Bir uygulama başlatın\n2. Çeviri yazıları açmak için ekranınızın sağ altında bulunan <b> cc </b> simgesini tıklayın\n\nÇeviri yazıları kapatmak için tekrar <b> cc </b> 'ye dokunmanız yeterlidir."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "Altyazınız var mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "Başarı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "Pazar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "Destek"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "Biz çok küçük bir şirketiz ve günde binlerce mesaj alıyoruz, bu nedenle bir yanıt sözü veremiyoruz, ancak size hemen geri dönmek için elimizden geleni yapacağız! Ödeme yapan müşterilerden gelen mesajlara öncelik verdiğimizi unutmayın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "Pratik yapmaya başlamak için aşağı kaydırın"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "Başlamak için dokunun"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "Teknik sorunlar"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "Kullanım Şartları"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "Teşekkürler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "Anketi doldurduğunuz için teşekkürler!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "Lütfen bu alanı doldurun"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "Zaman Çizelgesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "Daha fazla ayar göstermeyi aç / kapat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "Maksimum eşzamanlı indirme sayısına ulaştınız. Lütfen birinin bitmesini bekleyin ve tekrar deneyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "Tüm Pratikler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "Bütün Pratikler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "Bütün pratikler"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "Toplam Zaman"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "Toplam Süre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "Pratik yapılan toplam süre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "Sorun Giderme"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "Tekrar deneyin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "Ayarlar görünümünü yukarı kaydırıp Müzik'e ve ardından müzik türü için <b> Yok </b> 'a dokunarak uygulama içi müziği kapatabilirsiniz!\n \nKendi müziğinizi çalmak isterseniz, bunu cihazınızdaki diğer uygulamalar aracılığıyla yapabilirsiniz. Bununla birlikte, ses ipuçları telefonlarda ve tabletlerde varsayılan olarak maksimum ses düzeyine getirilirken, bazen bu, Spotify / iTunes / vb.'den gelen sesi güçlendirmek için yeterli değildir.\n \nBu durumlarda, müzik çalmak için harici bir hoparlör kullanmanızı veya arka planda müziğiniz kapalıyken bir dizüstü veya masaüstü bilgisayarda web sürümünü (https://www.downdogapp.com/web) kullanmanızı öneririz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "Pratik yaparken kendi müziğimi dinlemeyi tercih ederim. Müziği nasıl tamamen kapatırım?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "Ayyy, maalesef videoyu yükleyemedik"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "Bağlantılı pratik bu hesapla ilişkili değildir"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "bilinmeyen aygıt"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "Apple'dan bağlantıyı kaldır"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "Apple ile bağlantısını kaldırmak için bir şifre belirleyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "Facebook bağlantısını kaldır"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "Facebook bağlantısını kaldırmak için bir şifre belirleyin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "Google bağlantısını kaldır"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "Google bağlantısını kaldırmak için bir şifre belirleyin."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. <b> Ayarlar </b> 'a gidin. Mobilde, ekranın sağ alt tarafındaki üç yatay çizgiye dokunarak oraya gidebilirsiniz. Web'de Ayarlar sol kenar çubuğundadır.\n2. <b> Hesap </b> altında, <b> Google'dan Bağlantıyı Kaldır </b> 'a (veya <b> Facebook'tan Bağlantıyı Kaldır </b>) dokunun ve kullanmak istediğiniz yeni şifreyi Parola ve Parolayı Onayla alanları\n3. <b> Kaydet </b> 'e dokunun"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "Google / Facebook bağlantısını nasıl kaldırabilirim ve bunun yerine bir e-posta ve şifre kullanabilirim?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "Güncelleme"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "Uygulamanızın tamamı ters çevrildiyse, yansıtma işlevinin açık olmadığından emin olun! Nasıl kontrol edeceğiniz aşağıda açıklanmıştır!\n\nMobil uygulamada:\n1. Bir uygulama başlatın\n2. Ekranı çevirmek için ekranınızın sağ üst köşesinde <b> sağdan ikinci simgeye </b> dokunun\n\nWeb uygulamasında:\n1. Bir uygulama başlatın\n2. Ekranı çevirmek için ekranınızın sağ alt tarafında <b> soldan üçüncü simgeyi </b> tıklayın\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "Video, sesin bana söylediğinin tersine çevrildi."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "İşte deneyebileceğiniz birkaç şey:\n\n1. Uygulamayı kaldırın ve yeniden yükleyin\n\n2. Daha düşük kaliteli videoya geçin. <b>Diğer</b>'e ve ardından <b>Görsel Tip</b>'e dokunarak farklı görsel türler arasında geçiş yapabilirsiniz. Daha yüksek ve daha düşük kaliteli video seçeneklerini görmelisiniz.\n\n3. Yalnızca Web: Farklı bir tarayıcı deneyin. Down Dog en iyi Safari, Firefox ve Chrome ile çalışır."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "Pratiğin ortasında ekranım dondu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "Şu anda uygulamalarımızın her biri için yalnızca bir modelimiz var. Büyümeye devam ederken, sizin için daha fazla seçenek eklemeyi çok isteriz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "Videoda izleyebileceğim birden fazla model var mı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "Video Kalitesi"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "Çevrimdışı Uygulamayı Görüntüle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "Bir uygulamayı tamamladıktan sonra veya <b> Geçmiş </b> sayfanızdaki bir uygulamadan, alıştırmanız sırasında çalan şarkıların bir çalma listesini görmek için <b> Müzik </b> 'e dokunun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "Çalışmam sırasında hangi şarkılar çaldı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "Pozları Görüntüle"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "İnternete bağlı görünmüyorsun. Görsel türlerini değiştirmek için lütfen yeniden bağlanın."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "Ses"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "Uygulamaya yeni seslendirme sanatçıları ekliyoruz ve dönütünüzü istiyoruz! Aşağıdaki sesleri 1'den 5'e kadar puanlayarak bize ne kadar beğendiğinizi söyleyin. Lütfen teknik/ses kalitesi sorunlarını görmezden gelin ve onların gerçek seslerine ve çevirinin kulağa ne kadar doğal geldiğine odaklanın!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "Uygulamaya yeni seslendirme sanatçıları ekliyoruz ve dönütünüzü istiyoruz! Aşağıdaki seslerden hangisini sevdiğinizi 1'den 5'e kadar sıralayarak söyleyiniz. Lütfen teknik/ses kalitesi sorunları için kusura bamayın ve hangi sesleri sevdiğinizi söyleyin!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "Bu ödemenin geri ödenmesini ister misiniz? Aboneliğiniz iptal edilecek ve erişiminizi hemen kaybedeceksiniz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "Haftan ne zaman başlamalı?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "Haftalık Hedef"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "Haftalık bir hedef belirleyin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "Her hafta kaç uygulama yapmayı hedefleyeceksiniz?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "Naber?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "% ${p0} Tamamlandı"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "Yıllık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "Yıllık"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "Evet, Kaydol"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "Evet"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "Yoga"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "Yeni Başlayanlar İçin Yoga"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "Down Dog Yoga Pratiği"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "Yoga Nidra, derinlemesine rahatlatıcı, rehberli bir meditasyondur. Pratikte <b> Tür </b> altında bulabilirsiniz, sonuna kadar kaydırın.\n\nNot: <b> Yoga Nidra yalnızca sestir </b> - görüntü olmayacak.\n\nBirçok kişi uygulamada <b> Müzik </b> 'i Doğa Sesleri, Ortam, Beyin Dalgaları veya Piyano ve Yaylılar olarak ayarlamaktan hoşlanıyor ... birkaçını deneyin ve hangisini tercih ettiğinizi görün!\n\nYoga Nidra'da yeniyseniz, onu <b> Talimat Türü </b> <b> Tam Açıklama </b> veya <b> Varsayılan </b> olarak ayarlayarak dinlemenizi öneririz. Yoga Nidra'yı uykuya dalmak için de kullanabilirsiniz.\n\nEgzersiz Türü olarak Yoga Nidra'yı seçtikten sonra, <b> Odak </b> ve <b> Uyku </b> 'ya dokunun!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "Yoga Nidra nedir?"
}
